<template>
  <div class="cod-customer-search">
    <div class="search-results-container">
      <div class="left-column">
        <div class="search-container">
          <div class="field">
            <div class="control">
              <label class="label small-label">ຄົ້ນຫາລູກຄ້າ (ຊື່ ຫຼື ເບີໂທ)</label>
              <div class="input-with-button">
                <input
                  class="input"
                  type="text"
                  v-model="searchQuery"
                  placeholder="ຄົ້ນຫາ..."
                  @keyup.enter="searchCustomers"
                />
                <vs-button circle icon flat @click="searchCustomers" class="search-btn">
                  <i class="fal fa-search"></i>
                </vs-button>
              </div>
            </div>
          </div>
        </div>

        <div class="selected-customer" v-if="selectedCustomer">
          <div class="selected-label">ລູກຄ້າທີ່ເລືອກ:</div>
          <div class="selected-info">
            <div class="selected-name"><i class="fal fa-user"></i> {{ selectedCustomer.name }}</div>
            <div class="selected-tel"><i class="fal fa-phone"></i> {{ selectedCustomer.tel }}</div>
          </div>
        </div>
      </div>

      <div class="right-column">
        <div class="customer-list-container">
          <div class="customer-list" ref="customerList" v-if="customers.length > 0">
            <div
              v-for="(customer, index) in customers"
              :key="index"
              class="customer-item"
              :class="{ 'selected': selectedCustomer && selectedCustomer.id === customer.id }"
              @click="selectCustomer(customer)"
            >
              <div class="customer-info">
                <div class="customer-name"><i class="fal fa-user"></i> {{ customer.name }}</div>
                <div class="customer-tel"><i class="fal fa-phone"></i> {{ customer.tel }}</div>
              </div>
              <div class="select-icon" v-if="selectedCustomer && selectedCustomer.id === customer.id">
                <i class="fal fa-check-circle"></i>
              </div>
            </div>
          </div>
          <div class="no-results" v-else-if="searched && !isLoading">
            <p>ບໍ່ພົບຂໍ້ມູນລູກຄ້າ</p>
          </div>

          <div class="pagination" v-if="hasMorePages">
            <vs-button small flat @click="loadNextPage" class="next-btn">
              ໜ້າຕໍ່ໄປ <i class="fal fa-arrow-right"></i>
            </vs-button>
          </div>
        </div>
      </div>
    </div>

    <Loading v-if="isLoading" />
  </div>
</template>

<script>
import Loading from "@/views/Loading";

export default {
  name: "CodCustomerSearch",
  components: {
    Loading
  },
  props: {
    initialSelectedCustomer: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      searchQuery: "",
      customers: [],
      selectedCustomer: null,
      isLoading: false,
      currentPage: 1,
      hasMorePages: false,
      searched: false
    };
  },
  created() {
    if (this.initialSelectedCustomer) {
      this.selectedCustomer = this.initialSelectedCustomer;
    }
  },
  methods: {
    searchCustomers() {
      this.isLoading = true;
      this.currentPage = 1;
      this.fetchCustomers();
    },
    fetchCustomers() {
      this.$http.get("v2/auth/store/management/cod-customers", {
        params: {
          search: this.searchQuery,
          page: this.currentPage,
          per_page: 10
        }
      })
        .then(response => {
          this.customers = response.data.data;
          this.hasMorePages = response.data.current_page < response.data.last_page;
          this.searched = true;
          this.isLoading = false;
        })
        .catch(error => {
          console.error("Error fetching COD customers:", error);
          this.isLoading = false;
          this.customers = [];
          this.searched = true;
        });
    },
    loadNextPage() {
      this.currentPage++;
      this.isLoading = true;
      this.$http.get("v2/auth/store/management/cod-customers", {
        params: {
          search: this.searchQuery,
          page: this.currentPage,
          per_page: 10
        }
      })
        .then(response => {
          this.customers = response.data.data;
          this.hasMorePages = response.data.current_page < response.data.last_page;
          this.isLoading = false;
          this.$nextTick(() => {
            if (this.$refs.customerList) {
              this.$refs.customerList.scrollTop = 0;
            }
          });
        })
        .catch(error => {
          console.error("Error fetching more COD customers:", error);
          this.isLoading = false;
        });
    },
    selectCustomer(customer) {
      this.selectedCustomer = customer;
      this.$emit("customer-selected", customer);
    }
  },
  watch: {
    searchQuery: function(val, oldVal) {
      if (val === "" && val !== oldVal) {
        this.searchCustomers();
      }
    },
    initialSelectedCustomer: {
      deep: true,
      handler(val, oldVal) {
        // Handle the case when oldVal is null or undefined
        if (val && (!oldVal || val.id !== oldVal.id)) {
          this.selectedCustomer = val;
        }
      }
    }
  },
  mounted() {
    this.searchCustomers();
  }
};
</script>

<style lang="scss" scoped>
.cod-customer-search {
  margin-bottom: 8px;
  font-size: 1em;

  .search-results-container {
    display: flex;
    gap: 10px;
    min-height: 150px;

    .left-column {
      flex: 1;
      min-width: 180px;
      max-width: 250px;
    }

    .right-column {
      flex: 1;
      min-width: 180px;
    }

    .customer-list-container {
      position: relative;
      display: flex;
      flex-direction: column;
      min-height: 231px;
      height: 100%;
    }
  }

  .search-container {
    margin-bottom: 6px;

    .field {
      width: 100%;
    }

    .small-label {
      font-size: 0.9em;
      margin-bottom: 3px;
    }

    .input-with-button {
      display: flex;
      align-items: center;

      .input {
        flex-grow: 1;
        margin-right: 4px;
        height: 28px;
        padding: 0 8px;
        font-size: 0.95em;
      }

      .search-btn {
        flex-shrink: 0;
        height: 28px;
        width: 28px;
        min-height: 28px;
        min-width: 28px;
        padding: 0;
      }
    }
  }

  .customer-list {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    max-height: 180px;
    overflow-y: auto;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    margin-bottom: 5px;
  }

  .customer-item {
    padding: 6px 10px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.95em;

    &:hover {
      background-color: #f9f9f9;
    }

    &.selected {
      background-color: #e6f7ff;
    }

    .customer-info {
      .customer-name {
        font-weight: bold;
        font-size: 1em;

        i {
          margin-right: 5px;
          width: 14px;
          text-align: center;
          color: #1890ff;
        }
      }

      .customer-tel {
        font-size: 0.9em;
        font-weight: bold;

        i {
          margin-right: 5px;
          width: 14px;
          text-align: center;
          color: #1890ff;
        }
      }
    }

    .select-icon {
      color: #1890ff;
      font-size: 0.9em;
    }
  }

  .pagination {
    padding: 0;
    text-align: right;
    font-size: 0.9em;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 5px;

    .vs-button.next-btn {
      min-width: auto;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      padding: 0;
      background-color: #f9f9f9;
      transition: all 0.3s;
      font-size: 0.85em;
      color: #1890ff;

      i {
        font-size: 0.8em;
        margin-left: 3px;
      }

      &:hover {
        background-color: #e6f7ff;
        border-color: #ffffff;
      }
    }
  }

  .no-results {
    padding: 10px;
    text-align: center;
    color: #666;
    font-size: 0.95em;
    background-color: #f9f9f9;
    border-radius: 4px;
    margin-top: 5px;
  }

  .selected-customer {
    margin-top: 8px;
    padding: 8px 10px;
    background-color: #f0f8ff;
    border-radius: 4px;
    border: 1px solid #d6e9ff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    .selected-label {
      font-weight: bold;
      margin-bottom: 3px;
      font-size: 0.95em;
    }

    .selected-info {
      display: flex;
      flex-direction: column;
      gap: 3px;

      .selected-name {
        font-weight: bold;
        font-size: 0.95em;

        i {
          margin-right: 5px;
          width: 14px;
          text-align: center;
          color: #1890ff;
        }
      }

      .selected-tel {
        color: #666;
        font-size: 0.9em;

        i {
          margin-right: 5px;
          width: 14px;
          text-align: center;
          color: #1890ff;
        }
      }
    }
  }
}
</style>
